import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql } from 'providers/tanstack-query/utils'
import { DomainSliceDTO } from './types'

export const DOMAIN_FOR_FILTERING_RULE: TypedDocumentNode<DomainSliceDTO> = gql`
  fragment DomainFragmentForFilteringRule on Domain {
    id
    name
  }
`
